module.exports = __webpack_public_path__ + "static/media/Apple.080b0349.PNG";